import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // Header
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.services': 'Services',
    'nav.gallery': 'Gallery',
    'nav.contact': 'Contact',
    'temple.name': 'Sri Cherman Sithar Temple',
    'header.text': '🚨 Important Announcement 🚨 🙏 Hanuman Jayanti 🛕 📌 (December 19, 2025), Margazhi 4, Friday 🙏 We cordially invite everyone to participate and receive the blessings of Lord Hanuman.',
    
    // Hero
    'hero.title': 'Welcome to Arulmigu Sri Cherman Arunachala Swamy Temple',
    'hero.subtitle': 'A place of peace, prayer, and spiritual growth',
    'hero.cta': 'Explore',
    
    // About - Main History
    'about.title': '🕉️ Eral Cherman Arunachala Swamy – Savalaikkarankulam Temple History 🕉️',
    'about.subtitle': '(The History of the Grace-Bestowing Siddhar)',
    
    'about.history.birth': 'Sri Cherman Arunachala Swamy was born in Pudhukudi, a village in Thoothukudi District. Blessed with divine fortune, he attained spiritual enlightenment at a young age and rose as a graceful Siddhar who could alleviate the sufferings of people afflicted by evil spirits, black magic, witchcraft, curses, and mental illnesses. He stood as a pillar of support for the poor and underprivileged, becoming their source of mental strength and hope in life.',
    
    'about.dream.title': '🌙 Divine Vision – The Origin of the Temple',
    'about.dream.story': 'Mr. Velaiah resided in the peaceful village of Savalaikkarankulam in Nanguneri Taluk, Tirunelveli District. During a time of illness, he heard about one Arumugam from Thazhaikulam near Nanguneri, who was said to deliver divine prophecies through the grace of Cherman Arunachala Swamy. He visited there and was cured of his ailment. From that day onwards, he worshipped Sri Cherman Arunachala Swamy as his family deity.',
    
    'about.dream.vision': 'One day, after deeply worshipping Cherman Swamy, he went to sleep in his bedroom. It was a new moon day (Amavasai). S.Velaiah had a dream in which Swamy appeared and said: "Velaiah... let my abode be established here. I will sit here and bless the people. Build my temple here," and then disappeared.',
    
    'about.dream.result': 'That dream completely transformed his life. From that day, through the grace of Cherman Arunachala Swamy, he received the wisdom to deliver divine prophecies and spiritual insight. He built the temple on his own land.',
    
    // Temple Structure
    'about.temple.title': '🏛️ Temple Structure and Specialties',
    'about.temple.history': 'This temple has been serving spiritually for 50 years. Divine prophecies are delivered here twice a week, on Tuesdays and Fridays. Special pujas and free meals (Annadhanam) are offered on new moon days (Amavasai).',
    
    'about.deities.title': '🙏 Deities Enshrined in the Temple',
    'about.deities.list': '• Decorative Ganapathi at the entrance\n• Shakthi Vinayagar at the virgin corner\n• Two Vinayagars – embodiments of initiating divine energy\n• 5-foot-tall Abhaya Hastha Hanuman and Anjali Hastha Hanuman – two forms of Hanuman representing peace and power\n• Maha Kala Bhairava – the deity who can alter the judgments of time',
    
    // Testimonial
    'about.faith.title': '🙌 People\'s Faith and Devotion',
    'about.faith.quote': 'Today, this temple is called by devotees as "Parikara Sthalam" (Place of Remedies) and "Sathyame Arul" (Truth Itself is Grace). People say: "Once you come here, problems themselves run away in fear!"',
    
    // Admin
    'about.admin.title': '🙏 Administrator',
    'about.admin.name': 'Mr. S. Velaiah',
    'about.admin.desc': 'By Swamy\'s grace, he established this temple and continues to manage its growth and development.',
    
    // Final Message
    'about.conclusion': '📜 Savalaikkarankulam, today, is not just an ordinary village — it is the blessed six-foot ground of Eral Cherman Arunachala Swamy, where the merit established radiates as light to thousands of souls!',
    
    // Services/Events
    'services.title': '🎉 Temple Festivals and Worship',
    'services.description': 'Two days a week – Tuesday, Friday: Divine prophecies and special pujas',
    
    'services.weekly.title': 'Weekly Special Events',
    'services.weekly.tuesday': 'Tuesday - Divine Prophecy',
    'services.weekly.friday': 'Friday - Divine Prophecy',
    
    'services.monthly.title': 'Monthly Special Events',
    'services.monthly.amavasai': 'Amavasai (New Moon): Homams, worship, free meals',
    'services.monthly.thai': 'Thai Amavasai - Grand Abhishekam',
    'services.monthly.aadi': 'Aadi Amavasai - Special Worship',
    
    'services.annual.title': 'Annual Festivals',
    'services.annual.chithirai': 'Last Friday of Chithirai Month – Festival',
    'services.annual.margazhi': 'Margazhi Month – Hanuman Jayanthi',
    'services.annual.ashtami': 'Waning Moon Ashtami – Kala Bhairava Puja',
    
    'services.healing.title': '🍛 Special Services',
    'services.healing.desc': '• Homams to cure mental illness and black magic\n• Tadiyangar lamp and ghee lamp for Kala Bhairava\n• Free meals, remedial worship',
    
    'services.morning': 'Morning Prayer',
    'services.afternoon': 'Afternoon Aarti',
    'services.evening': 'Evening Prayer',
    'events.sunday': 'Spiritual Discourse',
    'events.wednesday': 'Meditation Session',
    'events.friday': 'Bhajan Evening',
    'events.saturday': 'Youth Program',
    'day.sunday': 'Sunday',
    'day.wednesday': 'Wednesday',
    'day.friday': 'Friday',
    'day.saturday': 'Saturday',
    
    // Gallery
    'gallery.title': 'Gallery',
    'gallery.description': 'Glimpses of our temple and spiritual activities.',
    
    // Contact
    'contact.title': 'Visit Us',
    'contact.description': 'Visit our temple and receive Swamy\'s blessings. Contact us for worship timings and details.',
    'contact.address': 'Address',
    'contact.phone': 'Phone',
    'contact.email': 'Email',
    'contact.hours': 'Hours',
    'contact.viewMap': 'View on Map',
    'contact.dailyHours': 'Daily: 6:00 AM - 9:00 PM',
    'contact.openDays': 'Open all days',
    'contact.formTitle': 'Send Us a Message',
    'contact.name': 'Name',
    'contact.namePlaceholder': 'Your name',
    'contact.emailPlaceholder': 'your@email.com',
    'contact.message': 'Message',
    'contact.messagePlaceholder': 'Your message',
    'contact.sendButton': 'Send Message',
    
    // Footer
    'footer.tagline': 'A place of peace, prayer, and spiritual growth',
    'footer.copyright': '© 2025 Sacred Temple. All rights reserved.',
  },
  ta: {
    // Header
    'nav.home': 'முகப்பு',
    'nav.about': 'பற்றி',
    'nav.services': 'சேவைகள்',
    'nav.gallery': 'தொகுப்பு',
    'nav.contact': 'தொடர்பு',
    'temple.name': 'ஸ்ரீ சேர்மன் சித்தர் திருக்கோவில்',
    'header.text': '🚨 முக்கிய அறிவிப்பு 🚨 🙏 அனுமன் ஜெயந்தி 🛕 📌 (டிசம்பர் 19, 2025), மார்கழி 4, வெள்ளிக்கிழமை 🙏 அனைவரும் கலந்துகொண்டு அனுமன் பெருமானின் அருளைப் பெற்றுச் செல்லுமாறு அன்புடன் அழைக்கிறோம். 🙏',
       
    // Hero
    'hero.title': 'அருள்மிகு ஸ்ரீ சேர்மன் அருணாசல சுவாமி திருக்கோவில்',
    'hero.subtitle': 'அருள் நிகழ்த்தரும் சித்தர் ஸ்தலம்',
    'hero.cta': 'ஆராயுங்கள்',
    
    // About - Main History
    'about.title': '🕉️ ஏரல் சேர்மன் அருணாச்சல சுவாமி – சவளைக்காரன்குளம் திருக்கோயில் வரலாறு 🕉️',
    'about.subtitle': '(அருள் நிகழ்த்தரும் சித்தர் வரலாறு)',
    
    'about.history.birth': 'தூத்துக்குடி மாவட்டம் புதுக்குடி என்னும் ஊரில் பிறந்தவர் ஸ்ரீ சேர்மன் அருணாச்சல சுவாமி. புண்ணிய அதிர்ஷ்டம் கொண்ட இவர், இளமையிலேயே தெய்வீக ஞானத்தில் நிலைத்து, மனிதர்கள் அனுபவிக்கும் பேய், பில்லி, சூனியம், ஏவல், மனநோய் போன்ற கஷ்டங்களைத் தீர்க்கும் அருள் வடிவான சித்தராக உயர்ந்தார். ஏழை எளிய மக்களுக்கு ஆதரவாக இருந்த அவர், மக்களின் மனவலிமை மற்றும் வாழ்வின் நம்பிக்கையாக மாறினார்.',
    
    'about.dream.title': '🌙 கனவால் கிடைத்த அருள் – கோவிலின் தோற்றம்',
    'about.dream.story': 'திருநெல்வேலி மாவட்டம் நாங்குநேரி தாலுகா சவளைக்காரன்குளம் என்னும் அமைதியான கிராமத்தில் வசித்தவர் திரு. வேலையா அவர்கள். உடல்நிலை சரியில்லாத நிலையில், நாங்குநேரி அருகிலுள்ள தாழைகுலத்தைச் சார்ந்த ஆறுமுகம் என்ற ஒருவர் சேர்மன் அருணாச்சல சுவாமி அருளால் அவர் அருள்வாக்கு கூறுவதாகக் கேள்விப்பட்டு, அங்கு சென்று உடல்நிலை குணமடைந்தார். அன்றிலிருந்து ஸ்ரீ சேர்மன் அருணாச்சல சுவாமியைத் தனது குடும்ப தெய்வமாக வணங்கி வந்தார்.',
    
    'about.dream.vision': 'அப்போது ஒரு நாள், சேர்மன் சுவாமியை ஆழமாக வணங்கிவிட்டு, அவர் தனது படுக்கை அறையில் உறங்கச் சென்றார். அன்று அமாவாசை நாளாக இருந்தது. வேலையா அவர்களுக்கு ஒரு கனவு வந்தது. அதில் சுவாமி தோன்றி: "வேலையா... என் தங்குமிடம் இங்கேயே அமையட்டும். மக்களுக்கு நான் இங்கே அமர்ந்து அருள் செய்யப் போகிறேன். நீ என் கோவிலை இங்கே அமைத்துவிடு," என்று கூறி மறைந்தார் சுவாமி.',
    
    'about.dream.result': 'அந்தக் கனவு அவரது வாழ்க்கையை முற்றிலும் மாற்றியது. அன்றிலிருந்து சேர்மன் அருணாச்சல சுவாமி அருளால் அருள்வாக்கு சொல்லும் ஞானத்தையும், ஆன்மீகச் சிந்தனையையும் பெற்றார். தன் சொந்த இடத்திலேயே அவர் கோவிலைக் கட்டினார்.',
    
    // Temple Structure
    'about.temple.title': '🏛️ கோவில் அமைப்பு மற்றும் சிறப்புகள்',
    'about.temple.history': '50 ஆண்டுகளாக இக்கோவில் ஆன்மீகச் சேவையில் உள்ளது. இங்கு வாரம் இரு முறை, செவ்வாய் மற்றும் வெள்ளிக்கிழமைகளில் அருள் வாக்கு சொல்லப்படுகிறது. அம்மாவாசை தினங்களில் சிறப்பு பூஜைகளும், அன்னதானமும் வழங்கப்படுகிறது.',
    
    'about.deities.title': '🙏 கோவிலில் அமர்ந்துள்ள தெய்வங்கள்',
    'about.deities.list': '• நுழைவாயில் அலங்கார கணபதி\n• கன்னி மூலையில் சக்தி விநாயகர்\n• இரண்டு விநாயகர் – தொடக்க சக்தியின் அருள் வடிவங்கள்\n• 5 அடி உயர அபய ஹஸ்த ஆஞ்சநேயர் மற்றும் அஞ்சலி ஹஸ்த ஆஞ்சநேயர் – இரண்டு ஆஞ்சநேயர் சாந்தியும் சக்தியும் தரும் உருவம்\n• மகாகாலபைரவர் – காலத்தின் தீர்ப்பை மாற்றும் தெய்வம்',
 
    // Testimonial
    'about.faith.title': '🙌 மக்களின் நம்பிக்கையும் பக்தியும்',
    'about.faith.quote': 'இன்றைய தினத்தில், இந்த கோவில் பக்தர்களால் "பரிகார ஸ்தலம்" என்றும், "சத்தியமே அருள்" என்றும் அழைக்கப்படுகிறது. மக்கள் சொல்வதென்னவெனில்: "இங்கே வந்துவிட்டால், பிரச்சனைகளே பயந்தே ஓடிவிடும்!"',
    
    // Admin
    'about.admin.title': '🙏 நிர்வாகி',
    'about.admin.name': 'திரு. ச. வேலையா',
    'about.admin.desc': 'சுவாமியின் அருளால் இக்கோவிலின் நிர்வாகத்தையும், வளர்ச்சியையும் எடுத்து நடத்தி வருகிறார்.',
    
    // Final Message
    'about.conclusion': '📜 சவளைக்காரன்குளம், இன்று ஒரு சாதாரண கிராமமல்ல — இது ஏரல் சேர்மன் அருணாச்சல சுவாமியின் அருள்மிகு ஆறடி நிலம், அங்கு பதித்த புண்ணியம், ஆயிரம் உயிர்களுக்கு ஒளியாய் வீசுகிறது!',
    
    // Services/Events
    'services.title': '🎉 கோவில் விழாக்கள் மற்றும் வழிபாடுகள்',
    'services.description': 'வாரம் இரு நாட்கள் – செவ்வாய், வெள்ளிக்கிழமை: அருள் வாக்கு சொல்லுதல், சிறப்பு பூஜைகள்',
    
    'services.weekly.title': 'வார சிறப்பு நிகழ்வுகள்',
    'services.weekly.tuesday': 'செவ்வாய் - அருள் வாக்கு',
    'services.weekly.friday': 'வெள்ளி - அருள் வாக்கு',
    
    'services.monthly.title': 'மாத சிறப்பு நிகழ்வுகள்',
    'services.monthly.amavasai': 'அம்மாவாசை: ஹோமங்கள், வழிபாடுகள், அன்னதானம்',
    'services.monthly.thai': 'தை அமாவாசை - மகா அபிஷேகம்',
    'services.monthly.aadi': 'ஆடி அமாவாசை - சிறப்பு வழிபாடு',
    
    'services.annual.title': 'ஆண்டு விழாக்கள்',
    'services.annual.chithirai': 'சித்திரை மாதம் கடைசி வெள்ளி – திருவிழா',
    'services.annual.margazhi': 'மார்கழி மாதம் – அனுமான் ஜயந்தி',
    'services.annual.ashtami': 'தேய்பிறை அஷ்டமி – காலபைரவர் பூஜை',
    
    'services.healing.title': '🍛 சிறப்பு சேவைகள்',
    'services.healing.desc': '• மனநோய் மற்றும் சூனியம் தீர்க்கும் ஹோமங்கள்\n• காலபைரவருக்கு தடியங்கார் தீபம், நெய் தீபம்\n• அன்னதானம், பரிகார வழிபாடுகள்',
    
    'services.morning': 'காலை பிரார்த்தனை',
    'services.afternoon': 'மதிய ஆரத்தி',
    'services.evening': 'மாலை பிரார்த்தனை',
    'events.sunday': 'ஆன்மீக உரை',
    'events.wednesday': 'தியான அமர்வு',
    'events.friday': 'பஜன் மாலை',
    'events.saturday': 'இளைஞர் நிகழ்ச்சி',
    'day.sunday': 'ஞாயிறு',
    'day.wednesday': 'புதன்',
    'day.friday': 'வெள்ளி',
    'day.saturday': 'சனி',
    
    // Gallery
    'gallery.title': 'தொகுப்பு',
    'gallery.description': 'சேர்மன் கோவிலின் ஆன்மீக நடவடிக்கைகளின் காட்சிகள்.',
    
    // Contact
    'contact.title': 'எங்களைப் பார்வையிடுங்கள்',
    'contact.description': 'சேர்மன் கோவிலுக்கு வருகை தந்து சுவாமி அருளைப் பெறுங்கள். வழிபாடு நேரங்கள் மற்றும் விவரங்களுக்கு தொடர்பு கொள்ளுங்கள்.',
    'contact.address': 'முகவரி',
    'contact.phone': 'தொலைபேசி',
    'contact.email': 'மின்னஞ்சல்',
    'contact.hours': 'நேரம்',
    'contact.viewMap': 'வரைபடத்தில் காண்க',
    'contact.dailyHours': 'தினசரி: காலை 6:00 - இரவு 9:00',
    'contact.openDays': 'எல்லா நாட்களும் திறந்திருக்கும்',
    'contact.formTitle': 'எங்களுக்கு ஒரு செய்தி அனுப்புங்கள்',
    'contact.name': 'பெயர்',
    'contact.namePlaceholder': 'உங்கள் பெயர்',
    'contact.emailPlaceholder': 'உங்கள்@மின்னஞ்சல்.com',
    'contact.message': 'செய்தி',
    'contact.messagePlaceholder': 'உங்கள் செய்தி',
    'contact.sendButton': 'செய்தியை அனுப்பு',
    
    // Footer
    'footer.tagline': 'அருள் நிகழ்த்தரும் சித்தர் ஸ்தலம்',
    'footer.copyright': '© 2025 ஸ்ரீ சேர்மன் அருணாசல சுவாமி திருக்கோவில்.'
  },
};

const LanguageContext = createContext(undefined);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('ta');

  const t = (key) => {
    return translations[language][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}